import { render, staticRenderFns } from "./footerItem.vue?vue&type=template&id=415334a0&scoped=true&"
import script from "./footerItem.vue?vue&type=script&lang=js&"
export * from "./footerItem.vue?vue&type=script&lang=js&"
import style0 from "./footerItem.vue?vue&type=style&index=0&id=415334a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415334a0",
  null
  
)

export default component.exports